import { useParams } from 'react-router-dom';
import { CaseDetailsApplicationContainer } from '../components/case-details-application.container';
import { SubPageLayout } from '../../../../sub-page-layout';
import { Helmet } from 'react-helmet';

export const CaseApplicationDetails: React.FC = () => {
  const params = useParams();
  return (
    <div style={{ marginTop: '25px' }}>
      <Helmet>
        <title>Case - Application</title>
      </Helmet>
      <SubPageLayout title={'Identity Verification Request'}>
        <CaseDetailsApplicationContainer caseId={params['caseId'] ?? ''} />
      </SubPageLayout>
    </div>
  );
};
